import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import type { TranslationKey } from 'src/types';
import { BackTextLink } from '../public/PublicReport/PublicReport.styles';

const StyledBackLink = styled(BackTextLink)<{ $changePassword: boolean }>`
  display: none;
  ${(props) => props.theme.newTypography.textStyleBodySmall}

  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: flex;
    margin-left: ${(props) => (props.$changePassword ? '30px' : '15px')};
    margin-top: ${(props) => (props.$changePassword ? '0' : '10px')};
  }
`;

const MobileBackButton = (props: {
  backText: TranslationKey;
  backTo: string;
  $changePassword?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <StyledBackLink
      $changePassword={props.$changePassword || false}
      to={props.backTo}
    >
      <KeyboardArrowLeft />
      {t(props.backText)}
    </StyledBackLink>
  );
};

export default MobileBackButton;
